import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { CardDealService } from '../card-deal.service';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';

@Component({
  selector: 'app-new-card-deal',
  templateUrl: './new-card-deal.component.html',
  styleUrls: ['./new-card-deal.component.scss'],
  providers: [ CardDealService ]
})
export class NewCardDealComponent extends BaseComponent implements OnInit {

  cardValues = [
    {value: 10, label: "10"},
    {value: 15, label: "15"},
    {value: 20, label: "20"},
    {value: 25, label: "25"},
    {value: 30, label: "30"},
    {value: 50, label: "50"},
    {value: 100, label: "100"},
    {value: -1, label: this.getString('multiple')}
  ];

  price: number;
  cardValue: number = this.cardValues[0].value;
  source = "";
  link = "";
  title = "";
  notes = "";
  deliveryType = 0;
  deliveryTypeEmail: boolean = false;
  deliveryTypeRetail: boolean = false;
  incompleteForm = false;
  invalidSource = false;
  invalidLink = false;
  error = false;
  success = false;
  priceDisabled: boolean = false;
  deliveryTypeChosen: boolean = true;

  @Output() onClose = new EventEmitter();

  constructor(
    private cardDealService: CardDealService
  ) {
    super();
  }

  ngOnInit() {

  }

  cancel() {
    this.onClose.emit();
  }

  close() {
    this.onClose.emit("true");
  }

  submit() {
    this.error = false;
    this.incompleteForm = false;
    this.invalidLink = false;
    this.invalidSource = false;

    let invalidForm = false;

    if(!this.deliveryTypeEmail && !this.deliveryTypeRetail) {
      this.deliveryTypeChosen = false;
      this.incompleteForm = true;
      invalidForm = true;
    }

    if (!this.title || !this.link || !this.cardValue) {
      this.incompleteForm = true;
      invalidForm = true;
    }

    if(!this.link.includes("http")) {
      this.invalidLink = true;
      invalidForm = true;
    }

    if(this.source.indexOf("http") >= 0) {
      this.invalidSource = true;
      invalidForm = true;
    }

    if(invalidForm) {
      return;
    }
    
    const price = this.price ? this.price.toString() : "-1";

    this.deliveryType = (this.deliveryTypeEmail && this.deliveryTypeRetail)? 0 : this.deliveryTypeEmail? 1 : 2;

    this.cardDealService.create(
      StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
      Global.getCountry(),
      Global.getStore(),
      this.title, this.notes, this.link, this.source, price,
      this.cardValue.toString(), this.deliveryType.toString()).subscribe(res => {
        if (res && res["status"] === "success") {
          this.success = true;
        }
        else {
          this.error = true;
        }
      }, err => {
        this.error = true;
      });
  }

  cardValueChange(e) {
    this.priceDisabled = e.target.value == "-1";
    this.price = this.priceDisabled ? null : this.price;
  }

}
